import { render, staticRenderFns } from "./RepoPosgradoPage.vue?vue&type=template&id=ebb48d40"
import script from "./RepoPosgradoPage.js?vue&type=script&lang=js&external"
export * from "./RepoPosgradoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports